export const DEFAULT_GAP: number = 6;
export const PAGE_ITEM_HEIGHT: number = 8; // 8 = 2rem = 32px
